import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "accommodation-experiences" };
const _hoisted_2 = { class: "container" };
const _hoisted_3 = {
    key: 0,
    class: "loading-state"
};
const _hoisted_4 = {
    key: 1,
    class: "error-state"
};
const _hoisted_5 = {
    key: 2,
    class: "experiences-grid"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_AccommodationCard = _resolveComponent("AccommodationCard");
    return (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            ($setup.loading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[1] || (_cache[1] = [
                        _createElementVNode("div", { class: "loading-spinner" }, null, -1),
                        _createElementVNode("p", null, "Cargando experiencias de alojamiento...", -1)
                    ]))]))
                : ($setup.error)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _cache[2] || (_cache[2] = _createElementVNode("i", { class: "fas fa-exclamation-triangle" }, null, -1)),
                        _createElementVNode("p", null, _toDisplayString($setup.error), 1),
                        _createElementVNode("button", {
                            onClick: _cache[0] || (_cache[0] =
                                //@ts-ignore
                                (...args) => ($setup.loadAccommodations && $setup.loadAccommodations(...args))),
                            class: "retry-button"
                        }, "Reintentar")
                    ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.accommodationExperiences, (experience) => {
                            return (_openBlock(), _createBlock(_component_AccommodationCard, {
                                key: experience.id,
                                image: $setup.getMainImage(experience),
                                title: experience.title,
                                location: experience.location,
                                price: $setup.formatPrice(experience.price_per_night),
                                description: experience.description,
                                badge: experience.badge,
                                to: { name: 'AccommodationDetail', params: { id: experience.id } }
                            }, null, 8, ["image", "title", "location", "price", "description", "badge", "to"]));
                        }), 128))
                    ]))
        ])
    ]));
}
